import { http } from "./http.js";

async function getAttachment(id) {
  const response = await http.get(`attachments/${id}/download`, {
    headers: { Accept: "application/x-binary" },
  });
  return response;
}

async function updateAttachment(id, title) {
  const response = await http.patch(`attachments/${id}/origin-name`, {
    OriginName: `${title}`,
  });
  return response;
}

async function deleteAttachment(resource, id) {
  const response = await http.delete(`${resource}/attachments/${id}`);
  return response;
}

async function uploadAttachment(resource, files) {
  const response = await http.post(resource, files);
  return response.data.map((a) => {
    return { id: a.Id, title: a.Title };
  });
}

async function updateAttachmentVisibility(id) {
  const response = await http.patch(`attachments/${id}/check`);
  return response;
}

async function createAttachment(resource, email, theme, selected) {
  const response = await http.post(resource, {
    email,
    theme,
    attachments: selected,
  });
  return response;
}

export {
  getAttachment,
  updateAttachment,
  deleteAttachment,
  uploadAttachment,
  updateAttachmentVisibility,
  createAttachment,
};
